import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export enum SensitivityEnum {
  HIGHLY_CONFIDENTIAL = "highly_confidential",
  CONFIDENTIAL = "confidential",
  INTERNAL = "internal",
  PUBLIC = "public",
  NOT_APPLICABLE = "non_applicable",
}

const twColorBySensitivity: { [S in SensitivityEnum]: string } = {
  [SensitivityEnum.HIGHLY_CONFIDENTIAL]:
    "border-rose-v2-300 bg-rose-v2-100 text-rose-v2-700",
  [SensitivityEnum.CONFIDENTIAL]:
    "border-error-v2-300 bg-error-v2-100 text-error-v2-600",
  [SensitivityEnum.INTERNAL]:
    "border-orange-v2-300 bg-orange-v2-100 text-orange-v2-600",
  [SensitivityEnum.PUBLIC]:
    "border-yellow-v2-300 bg-yellow-v2-100 text-yellow-v2-600",
  [SensitivityEnum.NOT_APPLICABLE]:
    "border-gray-v2-300 bg-gray-v2-100 text-gray-v2-500",
};

interface ISensitivityProps {
  sensitivity: { id: string; name: { en: string; vi: string } };
}

export const SensitivityLabel = ({ sensitivity }: ISensitivityProps) => {
  const {
    i18n: { language },
  } = useTranslation();

  const getSensitivityColor = useMemo(() => {
    if (
      Object.values(SensitivityEnum)
        .map((item) => item.toString())
        .includes(sensitivity.id)
    ) {
      return twColorBySensitivity[sensitivity.id as SensitivityEnum];
    }

    return twColorBySensitivity[SensitivityEnum.NOT_APPLICABLE];
  }, [sensitivity]);

  return (
    <div
      className={`min-w-20 flex items-center justify-center px-2 py-0.5 text-xs font-medium rounded-md border ${getSensitivityColor}`}
    >
      {language === "vi" ? sensitivity.name.vi : sensitivity.name.en}
    </div>
  );
};
